import React, {Component, useContext, useState, useEffect} from 'react';
import ReactDOM from 'react-dom';
import { Layout } from '../../../layouts';
import Welcome from '../../../layouts/welcome';
import Row from '../../../components/row';
import { ButtonCancel, ButtonModify, ButtonProceed, ButtonReturn, ButtonSave } from '../../../components/buttons';
import Container from '../../../layouts/containers/container';
import ContainerIndex from '../../../layouts/containers/container-index';
import ContainerTable from '../../../layouts/containers/container-table';
import adminApi from '../../../lib/admin/admin-api';
import MeApi from '../../../lib/users/me-api';
import Divider from '../../../components/divider/divider';
import List from '../../../components/list';
import { stringToFriendlyDatetime } from '../../../lib/helpers/datetime-helpers';
import PopupContext from '../../../context/context-popup';
import PopupsNewMessage from '../popups/popups-new-message';
import ButtonSend from '../../../components/buttons/button-send';

const Unread = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="20" viewBox="0 0 22 20">
            <path id="Path_441" data-name="Path 441" d="M18.8,8.493A5.023,5.023,0,0,0,22,8.9V20a1,1,0,0,1-1,1H3a1,1,0,0,1-1-1V4A1,1,0,0,1,3,3H16.1a5.01,5.01,0,0,0,1.093,4.241l-5.132,4.442L5.647,6.238,4.353,7.762l7.72,6.555ZM21,7a3,3,0,1,1,3-3A3,3,0,0,1,21,7Z" transform="translate(-2 -1)" fill="#fff"/>
        </svg>
    )
}

const Read = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="19.833" viewBox="0 0 20 19.833">
            <path id="Path_443" data-name="Path 443" d="M2.243,6.854,11.49,1.31a1,1,0,0,1,1.029,0l9.238,5.545A.5.5,0,0,1,22,7.284V20a1,1,0,0,1-1,1H3a1,1,0,0,1-1-1V7.283a.5.5,0,0,1,.243-.429ZM4,8.133V19H20V8.132L17.209,6.456,12,3.332l-8,4.8ZM12.06,13.7l5.3-4.463,1.288,1.53L12.074,16.3l-6.71-5.53L6.636,9.228,12.06,13.7Z" transform="translate(-2 -1.167)" fill="#354859"/>
        </svg>
    )
}

const TopRight = ({ fetch, searchParams }) => {
    const { setPopup } = useContext(PopupContext);
    const [ initialLoad, setInitialLoad ] = useState(true);

    // Using this crap component here because of the way the 
    // layout is using the context popup, i cannot open a popup
    // due to the way the props to the layout work within the provider
    // from within the layout itself

    const create = () => {
        let params = {}

        if (initialLoad) {
            params.searchParams = searchParams;
        }

        setPopup(<PopupsNewMessage fetch={fetch} { ...params }/>);
    }

    useEffect(() => {
        if (searchParams) {
            create();
            setInitialLoad(false);
        }
    }, []);

    return (
        <Row gap="20px">
            <ButtonSend onClick={create}>New</ButtonSend>
        </Row>
    )
}

export default class Messages extends Component {
    static contextType = PopupContext;

    constructor(props) {
        super(props);

        this.state = {
            errors: [],
            popup: null,
            selectedMessage: null,
            messages: [],
            currentPage: 1,
            meta: {},
            adminTeams: []
        };
    }

    componentDidMount() {
        this.fetch();
        this.fetchAdminTeams();
    }

    fetchAdminTeams() {
        adminApi.getAdminGroups().then(({ data }) => {
            this.setState({ adminTeams: data });
        }); 
    }

    formatSearchParams() {
        const searchParams = new URLSearchParams(window.location.search);

        const newMessage = searchParams.get('new');

        if (newMessage == 'true') {
            const adminTeamId = searchParams.get('admin_team') || '';
            const subject = searchParams.get('subject') || '';

            return {
                adminTeamId,
                subject
            }
        }

        return false;
    }

    fetch() {
        MeApi.getConversations({
            per_page: 10,
            page: this.state.currentPage,
            order_by: 'updated_at'
        }).then(({ meta, data }) => {
            this.setState({ messages: data, meta: meta });
        })
    }

    handleChange(e) {
        this.setState({[e.target.name] : e.target.value});
    }

    selectMessage(msg) {
        this.setState({ selectedMessage: msg });
    }

    openNewMessagePopup() {
        //this.setPopup(<PopupsNewMessage fetch={this.fetch.bind(this)} setPopup={this.setPopup.bind(this)}/>);
    }

    setPopup(popup) {
        this.setState({ popup })
    }

    getAdminTeam(team) {
        if (typeof team === 'object') return team?.name;

        return this.state.adminTeams.find(t => t.id === team)?.name;
    }

    render() {
        let messages = [];

        this.state?.messages?.forEach(msg => {
            messages.push([
                msg?.user_unread_messages?.length > 0,
                msg.subject,
                this.getAdminTeam(msg?.admin_team_id),
                msg.members,
                stringToFriendlyDatetime(msg.updated_at),
                msg.id,
            ])
        })

        return (
            <Layout 
                theme="dark"
                topLeft={
                    <Welcome 
                        title={'Messages'}
                        subtitle="My Conversations"
                    />
                }
                topRight={
                    <TopRight fetch={this.fetch.bind(this)} searchParams={this.formatSearchParams()}/>
                }
            >
                <Container className="messages-index">
                    <Container.Content>
                        <List gap='40px'>
                            <ContainerTable 
                                className="dashboard-progress" 
                                columns={[
                                    { field: 'STATUS', width: '10%' },
                                    { field: 'SUBJECT', width: '20.8196721%' },
                                    { field: 'TEAM', width: '20%' },
                                    { field: 'IN THIS CONVERSATION', width: '20%' },
                                    { field: 'LAST UPDATE', width: '20%' },
                                    { field: '', width: '9.1803279%' }
                                ]} data={[
                                    ...messages
                                ]}
                                style={{
                                    backgroundColor: 'transparent',
                                    padding: '0px',
                                }}
                                rowStyle={{
                                    backgroundColor: '#FCF7FF',
                                }}
                                replaceColumn={{
                                    0: (data) => {
                                        return (
                                            <div style={{
                                                backgroundColor: data === true ? '#FF7612' : '#F4EAFA',
                                                width: '100%',
                                                height: '100%',
                                                padding: '25px 0px',
                                                display: 'flex',
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                                borderRadius: '10px 0px 0px 10px'
                                            }}>
                                                { data === true ? <Unread/> : <Read/> }
                                            </div>
                                        )
                                    },
                                    3: (data) => {
                                        return (
                                            <Row gap="10px" alignItems="center">
                                                { data.map(message => {
                                                    return (
                                                        <Container.Icon src={message?.from?.user_profile?.profile_img || '/assets/user-icon.svg'} style={{ 
                                                            width: '30px',
                                                            height: '30px',
                                                            borderRadius: '50%',
                                                            backgroundColor: 'white',
                                                            border: '1px solid black'
                                                        }}/>
                                                    )
                                                })}
                                                { data > 5 && <Container.Text color="#C6C7D2">+ More</Container.Text> }
                                            </Row>
                                        )
                                    },
                                    5: (data) => {
                                        return (
                                            <Row style={{ 
                                                width: '100%',
                                                paddingRight: '25px' 
                                            }} justifyContent='flex-end'>
                                                <ButtonProceed transparent onClick={() => window.location.href = `/mydmc/messages/${data}`}>View</ButtonProceed>
                                            </Row>
                                        )
                                    }
                                }}
                            ></ContainerTable>
                            <ContainerIndex.Pagination
                                currentPage={this.state.currentPage}
                                maxPages={this.state.meta?.last_page}
                                onPrevious={() => this.setState({ currentPage: this.state.currentPage - 1 }, () => this.fetch())}
                                onNext={() => this.setState({ currentPage: this.state.currentPage + 1 }, () => this.fetch())}
                            />
                        </List>
                    </Container.Content>
                </Container>
            </Layout>
        )
    }
}

const el = document.getElementById('messages-index');

if (el) {
    ReactDOM.render(<Messages/>, el);
}
